var lists_default = {
  "fontElementMap": "_4X3JV",
  "orderedlist": "v6mQw",
  "bulletedlist": "_1XbUl",
  "listItem": "frioR",
  "checkboxList": "VU1nK",
  "checkboxInput": "mqFOv"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
